import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const getRel = (target) => (target === '_blank'
  ? 'noopener noreferrer' : undefined);

const withFullWidth = css`
  display: block;
  width: 100%;
`;

const withStyled = css`
  text-decoration: none;
`;

const Link = styled.a`
  ${({
    // eslint-disable-next-line no-shadow
    styled,
  }) => styled && withStyled}
  ${({ fullWidth }) => fullWidth && withFullWidth}
  color: var(--black-high);
`;

const Anchor = React.forwardRef(
  ({
    target,
    // eslint-disable-next-line no-shadow
    styled,
    fullWidth,
    children,
    ...props
  }, ref) => (
    <Link
      fullWidth={fullWidth}
      styled={styled}
      target={target}
      rel={getRel(target)}
      ref={ref}
      {...props}
    >
      {children}
    </Link>
  ),
);


Anchor.defaultProps = {
  children: null,
  fullWidth: false,
  styled: false,
  target: null,
  href: null,
};

Anchor.propTypes = {
  /** It's the content or label */
  children: PropTypes.node,
  /** Sets the href */
  href: PropTypes.string,
  /** Sets a style for covering all the container */
  fullWidth: PropTypes.bool,
  /** Sets basic anchor style */
  styled: PropTypes.bool,
  /** Sets the target */
  target: PropTypes.string,
};

Anchor.displayName = 'Anchor';

export default Anchor;
